<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" @click=openAdd() :title="$t('add')" icon="el-icon-edit"></el-button>
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">{{$t('add_time')}}{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.org_cname" :placeholder="$t('code_cname')">
                        <span slot="prepend">{{$t('org')}}{{$t('x_yd')}}</span>
                    </el-input>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table :data="listData" class="fillw show-scroll" height="100%">
                    <el-table-column fixed :label="$t('logo_img')" width="80px">
                        <template slot-scope="scope">
                            <myImgshow :src="scope.row.img_lnk" @onClick="$base.alertImg(scope.row.img_lnk, scope.row.org_cname)"></myImgshow>
                        </template>
                    </el-table-column>
                    <el-table-column fixed prop="org_code" :label="listHeader.org_code" width="100px"></el-table-column>
                    <el-table-column fixed prop="org_cname" :label="listHeader.org_cname" width="120px"></el-table-column>
                    <el-table-column width="120px" prop="mod_cname">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.mod_cname" :list="mods" v-model="search.mod_id"
                                        title_class="f12 f-blue" key_name="mod_cname" value_name="mod_id" @onChange="list()"></myDropdown>
                        </template>
                    </el-table-column>
                    <el-table-column width="120px" prop="join_type_cname">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.join_type_cname" :list="join_type" v-model="search.join_type"
                                        title_class="f12 f-blue" key_name="type_cname" value_name="join_type" @onChange="list()"></myDropdown>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fee_cat_cname" :label="listHeader.fee_cat_cname" width="100px"></el-table-column>
                    <el-table-column :label="listHeader.fee_amt" width="100px">
                        <template slot-scope="scope">{{scope.row.fee_amt}}{{$t('price_unit')}}</template>
                    </el-table-column>
                    <el-table-column width="140px">
                        <template slot-scope="scope" slot="header">
                            <myDropdown :title="listHeader.rw_status_cdesc" :list="rw_status" v-model="search.rw_status"
                                        title_class="f12 f-blue" key_name="value" value_name="key" @onChange="list()"></myDropdown>
                        </template>
                        <template slot-scope="scope">
                            <p>{{scope.row.rw_status_cdesc}}</p>
                            <a class="link" @click="rwApp(scope.row,false)" v-if="scope.row.rw_status == 'N'">
                                {{$t('app_rw')}}</a>
                            <a class="link" @click="rwApp(scope.row,true)" v-else-if="scope.row.rw_status == 'W' || scope.row.rw_status == 'V'">{{$t('cancel_rw')}}</a>
                            <div v-if="scope.row.rw_status != 'N'">{{scope.row.rw_time || scope.row.app_time}}</div>
                            <div class="f-red">{{scope.row.rw_remark}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="link_cname" :label="listHeader.link_cname" width="80px"></el-table-column>
                    <el-table-column prop="link_mobile" :label="listHeader.link_mobile" width="110px"></el-table-column>
                    <el-table-column :label="listHeader.addr" min-width="160px">
                        <template slot-scope="scope">{{scope.row.prov}}{{scope.row.city}}{{scope.row.area}}{{scope.row.addr}}</template>
                    </el-table-column>
                    <el-table-column prop="org_admin_user_cname" :label="listHeader.org_admin_user_cname" width="120px"></el-table-column>
                    <el-table-column prop="add_time" :label="listHeader.add_time" width="140px"></el-table-column>
                    <el-table-column fixed="right" :label="$t('op')" width="110px">
                        <template slot-scope="scope">
                            <a class="link" @click="openSave(scope.row.app_id)">{{$t('info')}}</a>
                            <a class="f-red" @click="del(scope.row.app_id)" v-if="['N','V'].includes(scope.row.rw_status)">删除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    import myPager from '../../../components/myPager'
    import myNodata from '../../../components/myNodata'
    import myDropdown from '../../../components/myDropdown'
    import myDatePicker from '../../../components/myDatePicker'
    import myImgshow from '../../../components/myImgshow'
    export default {
        name:"org-app",
        components:{
            myPager,
            myNodata,
            myDropdown,
            myDatePicker,
            myImgshow
        },
        data:function(){
            const listHeader = {
                img_lnk: this.$t('logo_img'),
                org_code: this.$t('org_code'),
                org_cname: this.$t('org_cname'),
                mod_cname: this.$t('org_mod_cname'),
                join_type_cname: this.$t('join_type_cname'),
                fee_cat_cname: this.$t('fee_cat'),
                fee_amt: this.$t('fee'),
                rw_status_cdesc: this.$t('rw_status'),
                rw_time:this.$t('rw_time'),
                link_cname: this.$t('link_cname'),
                link_mobile: this.$t('link_mobile'),
                addr: this.$t('addr'),
                org_admin_user_cname: this.$t('org_admin_code'),
                add_time: this.$t('add_time'),
                listHeaderEx:{
                    img_lnk:{type:'image',width:120,height:120}
                }
            };
            return{
                show_subview:false,
                relist:false,
                search:{
                    search_url: "org-app/list",
                    datearea_id:0,//如果大于0 mounted 要删除date_fr date_to
                    date_fr: '',
                    date_to: '',
                    page: 1,
                    limit: 30,
                    pageSize: 0,
                    org_cname: '',
                    mod_id: '',
                    join_type: '',
                    rw_status: 'NA',
                },
                listHeader,//表结构
                listData: [],
                totalData: {
                    total: 0,//总行数
                },
                mods:[
                    {
                        mod_id:'',
                        mod_cname:this.$t('all')
                    }
                ],
                join_type:[
                    {
                        join_type:'',
                        type_cname:this.$t('all')
                    }
                ],
                rw_status:[
                    {
                        key:'',
                        value:this.$t('all')
                    }
                ],
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();

            this.$base.listPageInit(this,()=>{
                this.getLoad();
            });
        },
        methods:{
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            getLoad: function() {
                var data = {};
                this.$base.showLoading();
                this.$request.sendPost("org-app/before-list",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.mods = this.mods.concat(data.mods);
                        this.join_type = this.join_type.concat(data.join_type);
                        this.rw_status = this.rw_status.concat(data.rw_status);
                        this.rw_status.push({
                            key:'NA',
                            value:'非已通过'
                        });
                        this.list();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            list: function (change_page) {
                this.$base.list(this, change_page);
            },
            exportExcel: function() {
                this.$base.exportExcel(this)
            },
            rwApp: function(item,cancel_flag){ //提交审核
                let data = {
                    app_id:item.app_id
                };
                var url = cancel_flag?'org-app/cancel-app':'org-app/rw-app';
                this.$base.rwApp(item,url, data, cancel_flag);
            },
            openAdd:function() {
                this.$base.linkTo('app/save', {op:'add'});
            },
            openSave:function (id) {
                this.$base.linkTo('app/save', {op:'upd',id});
            },
            del: function (app_id) {
                this.$base.confirm('您确认要删除当前申请吗',()=>{
                    var data = {
                        app_id: app_id
                    }
                    this.$base.showLoading();
                    this.$request.sendPost("org-app/del",data,(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.$base.msgSuccess('删除成功');
                            this.list(true);
                        }
                        else{
                            this.$base.msgErr(error.errmsg);
                        }
                    });
                });
            },
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(true);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/app/list.vue